/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Nav_Create_Folder_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Folder \"{name}\" created" |
*
* @param {Explorer_Nav_Create_Folder_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_create_folder_success_toast = /** @type {((inputs: Explorer_Nav_Create_Folder_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Create_Folder_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Dossier "${i?.name}" cree`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ordner "${i?.name}" erstellt`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Cartella "${i?.name}" creata`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Создана папка "${i?.name}".`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Carpeta "${i?.name}" creada`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`创建文件夹“${i?.name}”`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フォルダ「${i?.name}」を作成しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ़ोल्डर "${i?.name}" बनाया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Pasta "${i?.name}" criada`)
	return /** @type {LocalizedString} */ (`Folder "${i?.name}" created`)
});